import React from 'react';
import { connect } from 'react-redux';
import Dimmer from 'semantic-ui-react/dist/commonjs/modules/Dimmer';
import List from 'semantic-ui-react/dist/commonjs/elements/List';
import Loader from 'semantic-ui-react/dist/commonjs/elements/Loader';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import {
  getNotificationContent,
  getNotificationCount,
  markNotification
} from '../../redux/actions/notification-action/notification-action';
import PropTypes from 'prop-types';
import { Images } from '../../utils/constants';
import './notification_header_component.css';
import { NOTIFICATION_ICON } from '@Images';

class NotificationBell extends React.Component {
  UNSAFE_componentWillMount = async () => {
    let response = await this.props.getNotificationCount();
    if (
      response &&
      response.data &&
      response.data.success &&
      response.data.data &&
      response.data.data.count
    ) {
      this.setState({ unreadNotificationsCount: response.data.data.count });
    }
    this.timeout = setInterval(async () => {
      await this.props.getNotificationCount();
      let response = await this.props.getNotificationCount();
      if (response && response.data && response.data.success && response.data.data) {
        this.setState({ unreadNotificationsCount: response.data.data.count });
      }
    }, 600 * 2000);
  };

  componentWillUnmount = () => {
    clearInterval(this.timeout);
  };

  notifyParent = () => {
    let { onNotificationStateUpdate } = this.props;
    onNotificationStateUpdate && onNotificationStateUpdate(this.state.isOpen, this.handleClose);
  };

  getMoreNotifications = async (limit) => {
    let pageNumber = this.state.pageNumber;
    if (this.state.totalRecords > this.state.displayingRecords) {
      pageNumber = this.state.pageNumber + 1;
    }
    try {
      let response = await this.props.getNotificationContent(limit, pageNumber);
      if (response && response.data && response.data.success) {
        let { data, totalRecords } = response.data.data;
        this.setState({
          notificationList:
            this.state.displayingRecords < totalRecords
              ? this.state.notificationList.concat(data)
              : this.state.notificationList.length > 0
              ? this.state.notificationList
              : data,
          is_loading: false,
          displayingRecords:
            this.state.displayingRecords < totalRecords
              ? this.state.displayingRecords + data.length
              : this.state.displayingRecordsdata !== 0
              ? this.state.displayingRecordsdata
              : data.length,
          pageNumber: pageNumber,
          totalRecords: totalRecords
        });
        if (parseInt(this.state.unreadNotificationsCount, 10) !== 0) {
          let resp = await this.props.markNotification(null, true, 'seen'); // mark all as seen
          if (resp && resp.data && resp.data.success) {
            this.setState({ unreadNotificationsCount: 0 });
          }
        }
      }
    } catch (err) {
      //todo
    }
  };

  handleOpen = async () => {
    this.setState({ isOpen: true, is_loading: true });
    await this.getMoreNotifications(this.state.limit);
    this.setState({ is_loading: false }, this.notifyParent);
  };

  handleClose = () => {
    this.setState(
      {
        isOpen: false,
        displayingRecords: 0,
        notificationList: [],
        pageNumber: 0,
        totalRecords: 0
      },
      this.notifyParent
    );
  };

  markRead = async (id) => {
    try {
      let response = await this.props.markNotification([id], false, 'read');
      if (response && response.data && response.data.success) {
        this.handleClose();
      }
    } catch (err) {
      //
    }
  };

  renderNotificationList = (data) => {
    let returnJsx = data.map((key, index) => {
      return (
        <List.Item
          key={index}
          className={key.read ? 'read' : 'unread'}
          onClick={() => this.markRead(key.notification_id)}
        >
          <List.Content>
            <List.Header>{key.message.title}</List.Header>
            <div className="date-time">{key.created_at}</div>
            {key.message.body}
          </List.Content>
        </List.Item>
      );
    });
    return returnJsx;
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      notificationList: [],
      unreadNotificationsCount: 0,
      is_loading: false,
      pageNumber: 0,
      displayingRecords: 0,
      totalRecords: 0,
      limit: 5
    };
  }

  render() {
    const { NOTIFICATION_BELL_ICON_SBM } = Images;
    return (
      <div className="notification-header-component">
        {this.state.unreadNotificationsCount
          ? parseInt(this.state.unreadNotificationsCount, 10) > 0 && (
              <span className="unread-indicator">{this.state.unreadNotificationsCount}</span>
            )
          : null}
        {
          <Popup
            style={{
              left: 'auto',
              right: '6%',
              top: '65px',
              bottom: 'auto',
              border: '1px solid #f5f5f5',
              boxShadow: '3px 3px 0px 0px rgba(0,0,0,.07)',
              transform: 'translateZ(0)'
            }}
            // hideOnScroll
            trigger={
              <img
                className="headerTopRight_HelpIcon"
                src={this.props.isSbmReferral ? NOTIFICATION_BELL_ICON_SBM : NOTIFICATION_ICON}
                alt="notification icon"
                id="img-notification-icon"
              />
            }
            content={
              <div className="wrapper-notify">
                <List divided relaxed>
                  <Dimmer active={this.state.is_loading} inverted className="notification-dimmer">
                    <Loader />
                  </Dimmer>
                  {this.state.notificationList && this.state.notificationList.length ? (
                    this.renderNotificationList(this.state.notificationList)
                  ) : (
                    <List.Item className="read">
                      <List.Content>
                        {!this.state.is_loading && (
                          <span className="no-notification">No notifications yet.</span>
                        )}
                      </List.Content>
                    </List.Item>
                  )}
                  {this.state.totalRecords > this.state.displayingRecords && (
                    <List.Item className="see-more-list-item">
                      <List.Content>
                        <a
                          href="#!"
                          onClick={(e) => {
                            e.preventDefault();
                            this.getMoreNotifications(this.state.limit);
                          }}
                        >
                          See more
                        </a>
                      </List.Content>
                    </List.Item>
                  )}
                </List>
              </div>
            }
            on="click"
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            position="bottom center"
            className="notification-popup"
          />
        }
      </div>
    );
  }
}

NotificationBell.propTypes = {
  getNotificationContent: PropTypes.func,
  getNotificationCount: PropTypes.func,
  markNotification: PropTypes.func,
  onNotificationStateUpdate: PropTypes.func,
  isSbmReferral: PropTypes.bool
};

export default connect(null, {
  getNotificationContent,
  getNotificationCount,
  markNotification
})(NotificationBell);
